<template>
    <div>
        <div class="row">
            <div class="col-12 col-md-6">
                <emblem>Related level 2 legislation</emblem>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <v-client-table
                    ref="startOfResults"
                    class="custom-table"
                    :columns="columns"
                    :options="options"
                    :data="filteredList"
                    @row-click="onRowClick"
                >
                    <template v-slot:beforeTable>
                        <div class="legislation-monitor__table">
                            <text-input
                                v-model="selectedFilters.searchQuery"
                                name="search"
                                class="search mb-2 mb-md-0 mr-md-2"
                                label="Search subjects or legislation"
                            ></text-input>
                            <span class="reset mt-2" @click="resetFilters"
                                >Reset filters <i class="fas fa-times"></i
                            ></span>
                        </div>
                    </template>
                </v-client-table>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import VueTables from 'vue-tables-2';
import emblem from '@/components/emblem';
import textInput from '@/components/form/text-input';
import overview from '@/mixins/overview.js';
import transition_staggered_fade from '@/mixins/transition-staggered-fade-mixin.js';
import translationMixin from '@/mixins/translations';

Vue.use(VueTables.ClientTable);

export default {
    components: {
        emblem,
        textInput
    },
    mixins: [overview, transition_staggered_fade, translationMixin],
    props: {
        filters: {
            type: Object,
            default() {
                return {};
            }
        },
        levels: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            currentPage: 1,
            totalPages: 1,
            error: false,
            columns: ['name', 'code', 'type'],
            tableData: [],
            selectedFilters: {
                searchQuery: ''
            },
            options: {
                filterable: false,
                perPage: 10,
                perPageValues: [10],
                pagination: {
                    show: true
                }
            }
        };
    },
    computed: {
        filteredList() {
            const searchQuery = this.selectedFilters.searchQuery.toLowerCase();
            return this.levels.filter(
                level =>
                    level.code?.toLowerCase().includes(searchQuery) ||
                    level.name?.toLowerCase().includes(searchQuery)
            );
        }
    },
    watch: {
        selectedFilters: {
            deep: true,
            handler() {
                if (this.timeout) {
                    clearTimeout(this.timeout);
                }
                this.timeout = setTimeout(() => {
                    this.getItems();
                }, 400);
            }
        }
    },
    methods: {
        getItems() {},
        scrollToResults() {
            const element = this.$refs['startOfResults'];
            window.scrollTo({
                top: element.offsetTop - 300,
                behavior: 'smooth'
            });
        },
        resetFilters() {
            this.selectedFilters.searchQuery = '';
        },
        onRowClick(event) {
            window.location.href = event.row.url;
        }
    }
};
</script>

<style lang="scss" scoped>
.custom-table {
    color: black;

    ::v-deep {
        .VuePagination {
            justify-content: center;
        }

        .table-responsive {
            margin-bottom: 15px;
        }

        .VuePagination__count {
            display: none;
        }
    }
}
</style>
